var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c(Component,{tag:"component",attrs:{"socket":slotProps.socket}})]}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }